/**
 * 新华社稿取用记录
 */
"user strict";
angular.module('manageSysManageXHContributionAccessRecordsModule', [
		'manageSysManageXHContributionAccessRecordsRouterModule',
		'manageSysManageMediaNameDetailModule'
	])
	.controller('manageSysManageXHContributionAccessRecordsCtrl', ['$scope', 'trsHttpService', 'modalDialog', '$state', '$q', function($scope, trsHttpService, modalDialog, $state, $q) {

		initStatus();
		initData();

		/**
		 * [initStatus 初始化状态函数开始]
		 * @return {[type]} [description]
		 */
		function initStatus() {
			// 分页参数
			$scope.page = {
                CURRPAGE: 1, // 当前页
                PAGESIZE: 20, // 一页显示数据量
                ITEMCOUNT: 0, // 总数据量
                PAGECOUNT: 1, // 总页数
                gotoPage: 1, // 跳转到页数
            };
	        // 时间范围参数
	        $scope.time = {}
	        // 搜索关键词
	        $scope.keyword = '';
	        // 列表数据
	        $scope.items = [];
	        // 请求参数
	        $scope.params = {};
		}

		/**
		 * [initData 初始化数据]
		 * @return {[type]} [description]
		 */
		function initData() {
			requestData();
		}

		/**
		 * [requestData 接口--请求列表]
		 * @return {[type]} [description]
		 */
		function requestData() {
			var deffer = $q.defer();
			$scope.params = {
				serviceid: "mlf_xinhuashedoccount",
                methodname: 'queryXinhuasheDocCount',
                CurrPage: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
                BeginDate: '', // 稿件签发开始时间（yyyy-MM-dd 00:00:00）
                EndDate: '', // 稿件签发结束时间（yyyy-MM-dd 23:59:59）
                Name: $scope.keyword, // 产品名称(即搜索关键词)
                // MediaType: '' // 渠道类型（APP：1；网站：2；报纸：3；微信：4）
			}
			if(JSON.stringify($scope.time) !== '{}') {
				if($scope.time.startDate) {
					$scope.params.BeginDate = $scope.time.startDate + ' 00:00:00';
					$scope.params.EndDate = $scope.time.endDate + ' 23:59:59';
				}
			}
			// $scope.items = [];
        	// $scope.page.ITEMCOUNT = 0;
        	// $scope.page.PAGECOUNT = 1;
			$scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(res) {
	            $scope.items = res.DATA;
            	$scope.page.ITEMCOUNT = res.PAGER.ITEMCOUNT;
            	$scope.page.PAGECOUNT = res.PAGER.PAGECOUNT;
                deffer.resolve(res);
            });
            return deffer.promise;
		}

		/**
		 * [queryByDropdown 筛选条件触发后请求数据]
		 * @param  {[type]} key   [请求对象参数key]
		 * @param  {[type]} value [请求对象值]
		 */
		$scope.queryByDropdown = function(key, value) {
			// $scope.params[key] = value;
            $scope.page.CURRPAGE = 1;
            $scope.page.gotoPage = $scope.page.CURRPAGE;
            requestData();
		}

		/**
         * [fullTextSearch description] 搜索
         * @return {[type]} [description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                requestData();
            }
        };

		/**
         * [selectPageNum description] 选择一页要显示的数据量
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            // $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            // $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [pageChanged description] 下一页 页面改变调取数据
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.page.gotoPage = $scope.page.CURRPAGE;
            // $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            // $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [jumpToPage description] 跳转页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.page.gotoPage > $scope.page.PAGECOUNT) {
                $scope.page.gotoPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.page.gotoPage;
            // $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            // $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            requestData();
        };

		/**
		 * [gotoMediaDetail 跳转到媒体详情]
		 * @param  {[type]} item [description]
		 * @return {[type]}      [description]
		 */
		$scope.gotoMediaDetail = function(item) {
			localStorage.setItem("MetadataIds", item.METADTAIDS);
			var params = {
				NAME: item.NAME
			}
			if(JSON.stringify($scope.time) !== '{}') {
				params.BeginDate = $scope.time.startDate;
				params.EndDate = $scope.time.endDate;
			}
			$state.go('manageconfig.sysmanage.XHContributionAccessRecords.mediaNameDetail', params);
		}
	}])
